module.exports = __webpack_public_path__ + "img/right_angle_corner_icon.5fe4ef2a.svg";